import { gql } from '@apollo/client';

export const GET_COLUMNS = gql`
  query GetColumns($sourceDetails: SourceDetailsDto!) {
    getColumns(sourceDetails: $sourceDetails) {
      custom
      default
      id
      key
      name
      navigable
      orderable
      schema
      type
      searchable
    }
  }
`;

export const GET_RECORDS = gql`
query GetRecords ($sourceDetails: SourceDetailsDto!, $params: SourceParamsDto!){
  getRecordList(
    sourceDetails: $sourceDetails, params: $params
) {
 issues, issueObj
  }
}
`;
export const FETCH_WORKSPACES = gql`
query fetchWorkSpaces($user_email: String!){
  fetchWorkSpaces(
    user_email: $user_email
) 
{
  id
  name
  user_email
  created_date
  updated_date
  isParent
  description
  ownername
}
}
`;
export const FETCH_FOLDER = gql`
query fetchFolderByParent($parent: String!){
  fetchFolderByParent(
    parent: $parent
) {
  id
  name
  user_email
  created_date
  updated_date
  isParent
  parent
  l_id
}
}
`;
export const CREATE_WORKSPACE = gql`
query createWorkspace($workspace: WorkspaceDto!){
  createWorkspace(
    workspace: $workspace
) {
  id
  }
}
`;
export const CREATE_FOLDER = gql`
query createFolder($folder: FolderDto!){
  createFolder(
    folder: $folder
) {
  id
  }
}
`;
export const GetMembersOfWorkSpace=gql`
query getMembersOfWorkSpace($workspace_id:String!){
  getMembersOfWorkSpace(
    workspace_id:$workspace_id
  )
  {
    email
    username
  }
}
`;
//
export const DELETE_WORKSPACE_ITEM= gql`
mutation deleteWorkspace($workspace_id:String!){
  deleteWorkspace(
    workspace_id:$workspace_id
  )
}
`;

export const AddMemberToWorkspace=gql`
mutation addMemberToWorkspace($member: AddMemberDto!){
  addMemberToWorkspace( member: $member ) {
    success
    workspace_id
    notification{
      notification_id
      recipient_id
      sender_id
      message
      entity_id
      timestamp
      notification_type
      status
      metadata
      view
      accesslevel
    }
    access{
        id
        type
        compound_object
        access_created
        access_updated
        user_id
        entity_id
        sender_id
        highlevelaccess
        Read
        Write
        Share
        Delete
        view
        receiver_name
    }
  }
}
`;

export const CHANGE_RECORD_MUTATION = gql`
mutation ChangeRecord ($sourceDetails: SourceDetailsDto!,$params:ChangeRecordDto!){
  changeRecord(
    sourceDetails: $sourceDetails, params: $params
)
}
`;

export const GET_ALL_EVENTS_OF_USER = gql`
  query getAllEvents($user_email:String!){
   getAllEvents(user_email:$user_email)
  {
    id
    title
    description
    type
    start
    end
    creator
    status
    all_day 
    sheetid
    completed
  }
}
`;

export const DELETE_EVENT = gql`
mutation deleteEvent($eventId: String!)
  {
    deleteEvent(id:$eventId)
  }
`;

export const CREATE_EVENT=gql`
mutation createEvent($event: EventDTO!)
{
  createEvent(event:$event)
  {
    id
    title
    description
    type
    start
    end
    creator
    status
    all_day 
    sheetid
    completed
  }
}
`
export const UPDATE_EVENT = gql`
  mutation updateEvent($id: String!, $updatedEvent: EventUpdateDTO!) {
    updateEvent(id: $id, updatedEvent: $updatedEvent) {
      id
      title
      description
      type
      start
      end
      creator
      status
      all_day
      sheetid
      completed
    }
  }
`;

export const DELETE_EVENTS_ON_DELETESHEET= gql`
mutation deleteEventsOnDeleteSheet($sheetid:String!){
  deleteEventsOnDeleteSheet(
    sheetid:$sheetid
  )
}
`;